import styled from 'styled-components'
import { observer } from 'mobx-react'

import { theme } from 'styles/theme'
import { Heading1 } from '../Typography/Typography'

import type { ComponentProps } from 'react'

export const Main = styled.main`
  overflow-y: overlay;
  display: flex;
  flex-direction: row;
  block-size: 100%;
`

const PageWrapper = styled.div`
  position: relative;
  flex: 1 0 auto;
`

export interface PageProps extends ComponentProps<typeof PageWrapper> {}

// <Page /> currently contains just the PageWrapper, the navbar is displayed outside.
// However, we will keep it for the abstraction (maybe the page will contain more stuff later on?)
export const Page = observer(({ ...props }: PageProps) => {
  return <PageWrapper {...props} />
})

export const PageTitle = styled(Heading1)`
  color: ${theme.colors.Black};
  margin-block-end: 1em;
`

export type PageType = typeof Page

export const PageMainSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 1.5em;
  overflow: auto;
  position: absolute;
  inset: 0;
  background-color: ${theme.colors.LightBackground};
`

export const PageMainSectionCentered = styled(PageMainSection)`
  padding: 1em 17.5%;
  align-items: center;
`

interface SplitPageMainSectionProps {
  pageWidth: number
}

export const SplitPageMainSection = styled(PageMainSection)
.attrs((props: SplitPageMainSectionProps) => ({
  width: `${100*(1-(props.pageWidth || 0.5))}%`,
}))`
  inset: 0 ${props => props.width} 0 0;
  @media (max-width: ${theme.breakpoints.medium.max}) {
    inset: 0 0 ${props => props.width} 0;
  }
`

export const SplitPageAside = styled.aside.attrs((props: SplitPageMainSectionProps) => ({
  width: `${100*(1-(props.pageWidth || 0.5))}%`,
}))`
  position: absolute;
  inset: 0 0 0 ${props => props.width};
  overflow: auto;
  background-color: ${theme.colors.LightBackground};
  :is(:empty) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: ${theme.fontSizes.big};
    gap: 2em;
    ::before {
      content: '';
      background-image: url('../../assets/icons/flytrex-logo-first-letter.svg');
      background-size: contain;
      inline-size: 100%;
      block-size: 45vmin;
      background-position: center;
      background-repeat: no-repeat;
    }
    ::after {
      content: 'Empty content goes here. Override the style of both pseudo elements.';
      text-transform: uppercase;
    }
  }
  @media (max-width: ${theme.breakpoints.medium.max}) {
    inset: ${props => props.width} 0 0 0;
  }
`

export const PageDetailsSection = styled(SplitPageAside)`
  padding: 1.5em;
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.LightGrey};
  > *:only-child {
    margin: auto;
  }
`
